export default "__VITE_ASSET__D6V0TcW6__"